<template>
	<div class="wrap">
		<Xinde ref="xinde"></Xinde>
		<Huibao ref="huibao"></Huibao>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党务工作</el-breadcrumb-item>
				<el-breadcrumb-item>党员管理</el-breadcrumb-item>
				<el-breadcrumb-item>党员信息</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="dydetail">
						<div class="dyimg">
							<img src="@/assets/images/adminMan.png" v-if="u_pic==''||u_pic==null||u_pic.search('http')==-1">
							<img :src="u_pic" v-else>
						</div>
						<el-descriptions class="margin-top" :title="u_name" :column="3" >
							<template slot="extra">
								<el-button type="primary" size="small" @click="edit()">编辑</el-button>
								<el-button type="primary" size="small" @click="$router.go(-1)">返回上级</el-button>
							</template>
							<el-descriptions-item :key="index" v-for="(item,index) in detailList">
								{{item.name}} : 
								{{item.value}}
							</el-descriptions-item>
						</el-descriptions>
					</div>
					<div class="subtitle">
						<span :class="{selectBar:selectId == 4}" @click="changeData(4)">活动记录</span>
						<span :class="{selectBar:selectId == 1}" @click="changeData(1)">集中学习</span>
						<span :class="{selectBar:selectId == 3}" @click="changeData(3)">考试记录</span>
						<span :class="{selectBar:selectId == 5}" @click="changeData(5)">思想汇报</span>
					</div>
					<div class="selectdata">
						<myTables 
							:tableData="tableData"
							delkey="id"
							:tableHeader="tableHeader"
							:loading="true" 
							:indexs="false"
							:selection="false">
						</myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changePage"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { dygl } from '@/axios'
	import { Message } from 'element-ui'
	import Page from '@/components/page.vue'
	import myTables from '@/components/tables/tables.vue'
	import Xinde from './components/xinde.vue'
	import Huibao from './components/huibao.vue'
	export default{
		data(){
			return{
				getdata:{
					user_id:this.$store.state.user.userinfo.id,
					flag:this.$store.state.user.userinfo.flag,
					dw_name:this.$store.state.user.userinfo.dw_name,
					organ_class:"",
					sign:2
				},
				u_name:"",
				u_pic:'',
				detailList:[
					{
						name: "性别",
						value: "-",
						key: 'sex',
						icon: "el-icon-user-solid"
					},
					{
						name:"党员身份",
						key: 'u_zhiwu',
						value:"-",
						icon:"el-icon-s-custom"
					},
					{
						name:"民族",
						key: 'nation_name',
						value:"-",
						icon:"el-icon-s-check"
					},
					{
						name:"入党时间",
						key: 'attendtime',
						value:"-",
						icon:"el-icon-phone"
					},
					{
						name:"学历",
						key:'education_name',
						value:"-",
						icon:"el-icon-s-cooperation"
					},
					{
						name:"出生日期",
						value:"-",
						key:'age',
						icon:"el-icon-suitcase"
					},
					{
						name:"累计党组织活动(次)",
						key:'activity_count',
						value:"-",
						icon:"el-icon-location"
					},
					{
						name:"联系电话",
						key:'u_phone',
						value:"-",
						icon:"el-icon-user-solid"
					},
					{
						name:"身份证号",
						key:'card',
						value:"-",
						icon:"el-icon-user-solid"
					},
					{
						name:"通讯地址",
						key:'postal_address',
						value:"-",
						icon:"el-icon-user-solid"
					},
					{
						name:"所属单位",
						key:'company',
						value:"-",
						icon:"el-icon-s-data"
					}
				],
				zzname:"数据加载中",
				selectId:4, //1 集中学习    4 组织活动
				totalPage:0,
				tableData:[],
				pageSize:10,
				currentPage: 1,
				type:"edit",
				dialogVisible:false,
				tableHeader:[],
				organ_class:0,
				daoData:{}
			}
		},
		components:{Page,myTables,Xinde,Huibao},
		methods:{
			// 关闭弹窗
			closeEdit(){
				var that = this;
				that.dialogVisible = false;
				that.dataList();
			},
			detail(data){
				// 查看心得体会
				this.$refs.xinde.openXinde(data)
			},
			preview(){
				// 预览汇报
				// 查看心得体会
				this.$refs.huibao.openXinde("我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥我是大牛哥")
			},
			// 编辑
			edit(){
				var that = this;
				that.$router.push({
					path:'/dyxx_add',
					query:{
						id:that.$route.query.id,
						type:'edit',
						flag:that.$route.query.flag,
						uid:that.$route.query.uid,
						cy_zz:that.$route.query.cy_zz,
					},
				})
			},
			// 获取数据
			dataList(){
				var that = this;
				dygl.updateMemberBind({
					id:that.$route.query.id
				}).then(res => {
					if(res.code == 200){
						that.u_name = res.data.u_name
						for(let key in res.data){
							that.detailList.forEach((ele, label) => {
								if(ele.key === 'u_zhiwu'){
									ele.value = that.$changeZhiwu(res.data.u_zhiwu)
								}else{
									if(key === ele.key){
										ele.value = res.data[key] ? res.data[key] : '-'
									}
								}
							});
						}
					}
					that.changeData(4)
				})
			},
			// 切换数据
			changeData(selectId){
				var that = this;
				that.tableData = [];
				that.tableHeader = [];
				that.totalPage = 0;
				that.currentPage = 1;
				that.selectId = selectId;
				if(selectId == 1){
					that.tableHeader = [
						{prop:"title",width:"",label:"学习会议标题"},
						{prop:"k_time",width:"200",label:"时间"},
						{prop:"address",width:"300",label:"学习地点"},
					];
				}else if(selectId == 4){
					that.tableHeader = [
						{prop:"title",width:"",label:"活动主题"},
						{prop:"type",width:"300",label:"活动类型"},
						{prop:"k_time",width:"400",label:"时间"},
						{prop:"address",width:"",label:"活动地点"},
						// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
						{
							prop: 'oper', label: '操作', fixed: 'right', width: '114',align:'center',
							oper: [
								{name: '查看心得', style: {color:'#bb0000'}, clickFun: this.detail,show:true,limit:''},
							]
						}
					];
				}else if(selectId == 3){
					// 考试记录
					that.tableHeader = [
						{prop:"t_title",width:"",label:"考试名称"},
						{prop:"type",width:"300",label:"时间"},
						{prop:"k_time",width:"400",label:"分数"},
						{prop:"address",width:"",label:"是否及格"},
					];
				}else if(selectId == 5){
					// 思想汇报
					that.tableHeader = [
						{prop:"title",width:"",label:"汇报标题"},
						{prop:"type",width:"300",label:"时间"},
						// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
						{
							prop: 'oper', label: '操作', fixed: 'right', width: '114',align:'center',
							oper: [
								{name: '预览', style: {color:'#bb0000'}, clickFun: this.preview,show:true,limit:''},
							]
						}
					];
				}
				that.activity(selectId,1);
			},
			// 活动记录
			activity(type,page){
				var that = this;
				dygl.leaderHyLog({
					type:type,
					id:that.$route.query.id,
					page:page
				}).then(res => {
					that.tableData = res.data.pagedata;
					that.totalPage = res.data.count;
				})
			},
			changePage(val){
				var that = this;
				that.activity(that.selectId,val);
			}
		},
		mounted() {
			var that = this;
			that.dataList();
			that.$emit('selectTop',4);
		},
		created() {
			var that = this;
			that.$emit('selectTop',4)
		}
	}
</script>

<style lang="scss">
	.el-descriptions__title{
		display: flex;
		font-size: 20px;
		align-items: center;
	}
	.el-descriptions-item__label.has-colon::after{
		content: "" !important;
	}
	.dydetail{
		width: 100%;
		display: flex;
		.dyimg{
			width: 160px;
			height: 200px;
			background: #DDDDDD;
			margin-right: 20px;
			border-radius: 10px;
			img{
				width: 100%;
				height: 100%;
			}
		}
	}
	.el-descriptions{
		flex: 1;
	}
	.subtitle{
		width: 100%;
		height: 50px;
		border: 1px solid #DDDDDD;
		line-height: 50px;
		border-left: none;
		margin: 20px 0;
		color: #333;
		font-size: 14px;
		border-right: none;
		>span{
			display: inline-block;
			height: 100%;
			cursor: pointer;
			border-bottom: 2px solid rgba($color: #000000, $alpha: 0);
			padding: 0 20px;
		}
		>span:hover{
			color: #000000;
			border-bottom: 2px solid #bb0000;
		}
		.selectBar{
			color: #000000;
			border-bottom: 2px solid #bb0000;
		}
	}
</style>

